import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { postService } from '../api/services';
import './RelatedPosts.css';

// 相關文章區塊：依後端以共享標籤（不足時同頻道）算出的推薦清單渲染；無資料時整塊隱藏。
const RelatedPosts = ({ postId }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let alive = true;
    postService.related(postId)
      .then((res) => { if (alive) setPosts(res.data || []); })
      .catch(() => { if (alive) setPosts([]); });
    return () => { alive = false; };
  }, [postId]);

  if (!posts.length) return null;

  return (
    <div className="related-posts">
      <h3 className="related-title">🔗 相關文章</h3>
      <div className="related-list">
        {posts.map((p) => (
          <Link key={p.id} to={`/posts/${p.id}`} className="related-item">
            <span className="related-item-title">{p.title}</span>
            <span className="related-item-meta">
              <span>👁 {p.view_count || 0}</span>
              <span>👍 {p.vote_count || 0}</span>
              <span>💬 {p.comment_count || 0}</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;
